import { Dispatch, useReducer } from 'react';

import { assertUnreachable } from '../../../../util/assertUnreachable';

interface RenameFolderDialogState {
  isOpen: boolean;
  workspaceFolderId: string;
  workspaceId: string;
  initialWorkspaceFolderName: string;
}

type RenameFolderDialogAction =
  | { type: 'close' }
  | {
      type: 'open';
      payload: {
        workspaceFolderId: string;
        workspaceId: string;
        initialWorkspaceFolderName: string;
      };
    };

function renameFolderDialogReducer(
  state: RenameFolderDialogState,
  action: RenameFolderDialogAction
) {
  switch (action.type) {
    case 'open': {
      const { initialWorkspaceFolderName, workspaceFolderId, workspaceId } =
        action.payload;
      return {
        isOpen: true,
        initialWorkspaceFolderName: initialWorkspaceFolderName,
        workspaceFolderId: workspaceFolderId,
        workspaceId: workspaceId,
      };
    }
    case 'close': {
      return {
        isOpen: false,
        workspaceFolderId: null,
        workspaceId: null,
        initialWorkspaceFolderName: null,
      };
    }
    default: {
      assertUnreachable(action);
    }
  }
}

export function useRenameWorkspaceFolderDialog() {
  return useReducer(renameFolderDialogReducer, {
    isOpen: false,
    workspaceFolderId: null,
    workspaceId: null,
    initialWorkspaceFolderName: null,
  });
}

interface OpenRenameFolderParams {
  workspaceFolderId: string;
  workspaceId: string;
  initialWorkspaceFolderName: string;
}

export type RenameFolderDialogDispatch = Dispatch<RenameFolderDialogAction>;

export function openRenameFolder({
  workspaceFolderId,
  initialWorkspaceFolderName,
  workspaceId,
}: OpenRenameFolderParams) {
  return {
    type: 'open',
    payload: { workspaceId, workspaceFolderId, initialWorkspaceFolderName },
  } as const;
}

export function closeRenameFolder() {
  return {
    type: 'close',
  } as const;
}
